import React from 'react';
import styled from 'styled-components';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import EsperLogoBlue from '../assets/v2/esper.svg';
import '../layout/layout.scss';
import EsperSignUpClass from '../components/HomePage/EsperSignUpFormComponent';
import { Link } from 'gatsby';
import Layout from '../layout';
import messages from '../i18n/en';

const BookDemoContainer = styled.div`
  position: relative;
  height: auto;
  display: grid;
  align-content: center;
  min-height: 100vh;
  background: linear-gradient(
    241deg,
    rgba(246, 244, 244, 0),
    rgba(248, 247, 250, 0.69) 21%,
    #f9f9fd 50%,
    rgba(236, 236, 238, 0.59) 79%,
    rgba(216, 216, 216, 0)
  );
`;
class IndexPage extends React.Component<any, any> {
  state = {
    isBrowser: false,
  };
  componentDidMount() {
    if (window['grecaptcha']) {
      window.grecaptcha.ready(() => {
        this.setState({ isBrowser: true });
      });
    }
    window.onLoadCallback = this.onRecaptchaLoaded;
  }

  onRecaptchaLoaded = () => {
    if (window['grecaptcha']) {
      window.grecaptcha.ready(() => {
        this.setState({ isBrowser: true });
      });
    }
  };

  render() {
    return (
      <Layout
        messages={messages}
        recaptcha={true}
        keywords={`Esper Signup, Esper Free Trial, Android DevOps software`}
        description={`It's free to sign up for Esper's powerful cloud platform for Android DevOps and single-purpose device EMM. Provision 10+ devices and access 24/7 support. `}
        fullScreen={true}
        location={this.props.location}
        title={'See Esper In Action. Sign Up for a Free Trial Today.'}
        className="first-page"
      >
        {this.state.isBrowser ? (
          <EsperSignUpClass
            currentLanguage={messages?.locale}
            messages={messages}
            isDeveloper={false}
          />
        ) : (
          <BookDemoContainer>
            <Link
              style={{ justifySelf: 'center' }}
              aria-label="Esper Logo"
              title="Esper Logo"
              to={`${
                messages?.locale !== 'en' ? `/${messages?.locale}/` : '/'
              }`}
            >
              <LazyLoadImage
                alt="Esper logo"
                style={{
                  height: '44px',
                  width: '180px',
                  marginTop: '2rem',
                  marginBottom: '2rem',
                }}
                src={EsperLogoBlue}
              />
            </Link>
          </BookDemoContainer>
        )}
      </Layout>
    );
  }
}

export default IndexPage;
